<svg class="stacked-area-chart">
  <defs>
    <linearGradient id="linearGradient0" x1="0%" y1="100%" x2="25%" y2="15%">
      <stop offset="0%" stop-color="white" stop-opacity="0"></stop>
      <stop offset="100%" stop-color="#F4A22E" stop-opacity="0.5"></stop>
    </linearGradient>
    <linearGradient id="linearGradient1" x1="0%" y1="100%" x2="25%" y2="15%">
      <stop offset="0%" stop-color="white" stop-opacity="0"></stop>
      <stop offset="100%" stop-color="#98B172" stop-opacity="0.5"></stop>
    </linearGradient>
    <linearGradient id="linearGradient2" x1="0%" y1="100%" x2="25%" y2="15%">
      <stop offset="0%" stop-color="white" stop-opacity="0"></stop>
      <stop offset="100%" stop-color="#A3D0DA" stop-opacity="0.5"></stop>
    </linearGradient>
  </defs>
</svg>

<div id="stacked-area-chart-tooltip" class="stacked-area-chart-tooltip">
  <p>{{ translations.expectedValue }} {{ (tooltipData.value.toFixed(0)) | thousand }}</p>
  <p>{{ translations.investment }} {{ (tooltipData.invested.toFixed(0)) | thousand }}</p>
  <p>{{ translations.year }} {{ tooltipData.year }}</p>
</div>

<div class="stacked-area-chart__legend">
  <div
    class="stacked-area-chart__legend-item"
    *ngFor="let item of data.columns; let i = index"
    (click)="handleSelection(i - 1)"
    [class.inactive]="selectedIndex !== null && selectedIndex !== i - 1"
  >
    {{ translations ? translations[item] : '' }}
  </div>
</div>
